import React from "react";
import AppOverviewBg from "../Assets/img/app-overview.jpg";
import VideoPlayerPopup from "./VideoPlayerPopup";
const AppOverview = () => {
  return (
    <>
      <div
        className="app-overview-area"
        style={{ backgroundImage: `url(${AppOverviewBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="app-overview-content">
                <VideoPlayerPopup />
                <span>App Overview Test</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AppOverview;
